import styled from 'styled-components';

export const CuratorNameInsteadOfLogo = styled.span`
  font-size: 14px;
  white-space: nowrap;
`;
